import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {RegionModel} from '../../../../models/RegionModel';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {RegionService} from '../../../general-services/service-region-anagraf/region-service.service';
import * as toastr from 'toastr';

@Component({
  selector: 'app-edit-region-anagraf',
  templateUrl: './edit-region-anagraf.component.html',
  styleUrls: ['./edit-region-anagraf.component.scss']
})
export class EditRegionAnagrafComponent extends ProjectConstants implements OnInit, OnDestroy {
  region: RegionModel;
  formValidator: FormGroup;
  formBuilder: FormBuilder;

  saveSubscribe: Subscription;
  parameterSubscribe: Subscription;

  idRegion: number;
  codRegion: string;
  description: any;
  regionJson: any;
  submitted: boolean;

  constructor(private route: ActivatedRoute, private router: Router,
              private regionService: RegionService, private _Activatedroute: ActivatedRoute) {
    super();

    this.parameterSubscribe = this.route
      .queryParams
      .subscribe(params => {
        this.regionJson = params['row'];
      });

    this.region = new RegionModel();

    this.formBuilder = new FormBuilder();

    this.formValidator = this.formBuilder.group({
      cod: [{value: '', disabled: false}, Validators.required],
      description: [{value: '', disabled: false}, Validators.required]
    });

    this.region = JSON.parse(this.regionJson) as RegionModel;

    this.formValidator.patchValue({
      cod: this.region ? this.region.cod : ''
    });

    this.formValidator.patchValue({
      description: this.region ? this.region.description : ''
    });

    _Activatedroute.params.subscribe(params => {
      this.idRegion = params['id'];
      this.codRegion = params['cod'];
      this.description = params['description'];
    });
  }

  ngOnInit() {
  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.REGION_ANAGRF]);
  }

  edit() {
    this.submitted = true;
    if (this.formValidator.valid) {
      this.region.cod = this.formValidator.controls['cod'].value;
      this.region.description = this.formValidator.controls['description'].value;
      this.saveSubscribe = this.regionService.update(this.regionService.baseUrl, this.region).subscribe(
        (result: any) => {
          if (result === -1) {
            toastr.options.timeout = 5000;
            toastr.warning('Duplicate item, Region Cod already exists', 'Warning');
          } else if (result === -2) {
            toastr.options.timeout = 5000;
            toastr.warning('Element already used', 'Warning');
          } else {
            toastr.success('Region with id ' + this.idRegion + ' was edited with success', 'Success');
            this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.REGION_ANAGRF]);
          }
        }, error => {
          toastr.error('Region was not edited', 'Error');
        });
    }
  }

  ngOnDestroy(): void {
    if (this.saveSubscribe) {
      this.saveSubscribe.unsubscribe();
    }
  }

}

